import React from 'react'
import { Badge, BadgeProps } from 'components/Badge'
import { Button, ExtendedButtonProps } from 'components/Button'
// import { Text } from 'components/Text'
// import { useViewport } from 'hooks'

export type FiltersDialogButtonProps = ExtendedButtonProps & { appliedCount?: number, BadgeProps?: BadgeProps }

export const FiltersDialogButton: React.FC<FiltersDialogButtonProps> = ({ appliedCount, BadgeProps, children, ...props }) => {
  // const { isMedium} = useViewport()

  if (appliedCount && appliedCount > 0) {
    return <Button {...props} sx={[
      { pl: 0, pr: 2 },
      ...(Array.isArray(props?.sx) ? props?.sx : [props?.sx])
    ]}>
      <Badge
        color="primary"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        {...BadgeProps}
        badgeContent={appliedCount}
        sx={[
          { '& .MuiBadge-badge': { mt: 1.5, mr: -1.5 } },
          ...(Array.isArray(BadgeProps?.sx) ? BadgeProps?.sx : [BadgeProps?.sx])
        ]}
      >
        { children }
      </Badge>
    </Button>
  }

  return <Button {...props} sx={[
    (theme) => ({ px: 1, minWidth: theme.spacing(6) }),
    ...(Array.isArray(props?.sx) ? props?.sx : [props?.sx])
  ]}>
    { children }
  </Button>
}

export default FiltersDialogButton
